














import { Component, Vue } from 'vue-property-decorator';
import Review from '@/components/organisms/Review/Review.vue';
import FeedbackService from '@/api/FeedbackService';
import FeedbackPage from './FeedbackPage.vue';
import segmentIo from '@/utils/segment.io';

@Component({
  components: {
    Review,
    FeedbackPage
  }
})
export default class FeedbackPlatform extends Vue {
  service = new FeedbackService();
  hasSendFeedback = false;
  loading = false;

  get tPrefix() {
    return 'common.components.feedback';
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get defaultRating() {
    return this.$route.query.rating || 0;
  }

  get businessId(): any {
    return this.$route.query.businessId;
  }

  get customerId(): any {
    return this.$route.query.customerId;
  }

  successClick() {
    segmentIo.track('Clicked Email Feedback Platform Success Close');

    this.$router.replace('/');
  }

  sendFeedback({ rating, comment, provider }: any) {
    segmentIo.track('Clicked Email Feedback Platform Submit', {
      rating,
      provider
    });
    return this.service.sendFeedbackEmail({
      rating,
      comment,
      businessId: this.businessId,
      customerId: this.customerId,
      provider
    });
  }

  async created() {
    segmentIo.page('Email Feedback Platform');
    this.$showLoader();
    this.loading = true;
    try {
      const { data } = await this.service.getFeedbackEmail(
        this.businessId,
        this.customerId
      );

      this.hasSendFeedback = !data.available;
    } finally {
      this.$hideLoader();
      this.loading = false;
    }
  }
}
